import React, { useEffect, useState, useImperativeHandle, forwardRef} from 'react'
import { GetPaymentTokenEntity, GetReservation } from '../../api/services/pms'
import { onError } from '../shared/messages'
import CardList from './cardList'
import PropTypes from "prop-types";
import { EntityType } from '../shared/constants';

const SavedCardsList = forwardRef(({
    reservation, hotelid, newtoken, header, footer, selectFirst, allowedPaymentProviderIDs, onLoadListFinished, getEntitiesByUser, ...rest }, ref) => {
    const [tokens, setTokens] = useState([])
    const [selectedId, setSelectedId] = useState(null)
    const reservationID = reservation ? reservation.Id : null
    const reservationEntity = reservation && reservation.entities &&
        reservation.entities.find(e => e.EntityTypeId === EntityType.Reservation);
        
    const getEntityTypeId = () => {
        if (getEntitiesByUser) {
            return EntityType.Guest;
        } else {
            return reservationEntity ?
                reservationEntity.EntityTypeId :
                (reservation.Id ? EntityType.Reservation : EntityType.Folio)
        }
    };
    const getEntityId = () => {
        if (getEntitiesByUser) {
            return reservation.GuestId
        } else {
            return reservationEntity ?
                reservationEntity.EntityId :
                (reservation.Id || reservation.FolioId)
        }
    };

    const reload = async (tokenIdToSelect = null) => {
        try {
            let tokens = await GetPaymentTokenEntity({
                "HotelId": hotelid,
                "EntityTypeIds[0]": getEntityTypeId(),
                "EntityIds[0]": getEntityId(),
                "IsGetRelatedToEntity": true
            });

            if (reservation) {
                const filterTokens = (res) => {
                    return tokens.filter(x => {
                        if (x.EntityTypeID == EntityType.Agent) {
                            if (allowedPaymentProviderIDs)
                                return x.EntityId == res.AgentID && allowedPaymentProviderIDs.includes(x.PaymentProviderID);
                            else
                                return x.EntityId == res.AgentID;
                        }
                        if (x.EntityTypeID == EntityType.Company) {
                            if (allowedPaymentProviderIDs)
                                return x.EntityId == res.CompanyID && allowedPaymentProviderIDs.includes(x.PaymentProviderID);
                            else
                                return x.EntityId == res.CompanyID;
                        }
                        if (x.EntityTypeID == EntityType.Guest) {
                            if (allowedPaymentProviderIDs)
                                return x.EntityId == res.GuestId && allowedPaymentProviderIDs.includes(x.PaymentProviderID);
                            else
                                return x.EntityId == res.GuestId;
                        }

                        return false;
                    })
                }
                if (!reservation.AgentID && !reservation.CompanyID && !reservation.GuestId) {
                    if (reservation.Id) {
                        // This is not a FULL reservation object so get the reservation from the server
                        const res = await GetReservation({
                            Ids: reservationID,
                            HotelId: hotelid,
                            IncludeCanceled: true
                        })
                        tokens = filterTokens(res)
                    } else if (reservation.entities) {
                        const getEntityId = type => {
                            const entity = reservation.entities.find(x => x.EntityTypeId === type)
                            return entity ? entity.EntityId : null
                        }
                        const res = {
                            ...reservation,
                            AgentID: getEntityId(EntityType.AGENT),
                            CompanyID: getEntityId(EntityType.COMPANY),
                            GuestId: getEntityId(EntityType.Guest)
                        }
                        tokens = filterTokens(res)
                    }
                } else {
                    tokens = filterTokens(reservation)
                }
            }
            setTokens(tokens)

            if (onLoadListFinished) {
                onLoadListFinished("SavedCards", tokens.length)
            }

            // If there is a specific token to select (from a parameter or a prop)
            const idToSelect = tokenIdToSelect
            if (idToSelect && rest.onSelect) {
                const tokenToSelect = tokens.find(t => t.PaymentTokenId === idToSelect)
                if (tokenToSelect) {
                    setSelectedId(tokenToSelect.PaymentTokenId)
                    rest.onSelect(tokenToSelect.Id)
                    if (rest.onSelectItem) {
                        rest.onSelectItem(tokenToSelect)
                    }
                }
            }
            //selectFirst=true
            else if (tokens.length && selectFirst && rest.onSelect) {
                setSelectedId(tokens[0].PaymentTokenId)
                rest.onSelect(tokens[0].Id)
                if (rest.onSelectItem) {
                    rest.onSelectItem(tokens[0])
                }
            }
        } catch (error) {
            onError(error)
        }
    }

    useEffect(() => {
        if (reservation && (reservation.Id || reservation.FolioId)) {
            reload()
        }
    }, [reservation?.Id, getEntitiesByUser])

    useEffect(() => {
        if (newtoken) {
            setTokens([
                ...tokens,
                newtoken
            ])
        }
    }, [newtoken])

    // Expose reload to external components
    useImperativeHandle(ref,() => ({
        reload
    }));
    
    return <div>
        {header}
        {tokens.length ? <CardList items={tokens} selected={selectedId} {...rest} /> : null}
        {footer}
    </div>
});
SavedCardsList.propTypes = {
    reservation: PropTypes.any,
    hotelid: PropTypes.any,
    header: PropTypes.any,
    footer: PropTypes.any,
    newtoken: PropTypes.any,
    selectFirst: PropTypes.bool,
    allowedPaymentProviderIDs: PropTypes.array,
    onLoadListFinished: PropTypes.func,
    getEntitiesByUser: PropTypes.bool,
}
export default SavedCardsList